var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialsCurl2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 285,
    viewBox: "0 0 367 285",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1238_1628",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 367,
    height: 285
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 367,
    height: 285,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1238_1628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M943.254 236.933C606.798 -56.388 79.4796 -5.88814 257.431 172.512C274.232 187.289 314.683 220.949 375.194 215.192C450.832 207.996 421.631 167.423 367.365 154.492C338.922 147.715 153.307 135.835 114.331 227.685C75.3547 319.535 182.435 348.45 303.06 321.727C310.1 318.656 310.937 316.914 304.97 313.772C288.254 304 125.831 390.915 79.9558 520.562",
    stroke: "white",
    strokeWidth: 31.9132
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialsCurl2);
export default __webpack_public_path__ + "static/media/socials_curl2.428ee9d8d3551196b417ddc6b33cc202.svg";
export { ForwardRef as ReactComponent };